var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBoba = function SvgBoba(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u5E01\u79CD")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u57FA\\u7840\\u670D\\u52A1\\uFF081117\\u66F4\\u65B0\\uFF09",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4EA4\\u6613\\u8BB0\\u5F55",
    transform: "translate(-40.000000, -285.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(0.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(20.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(20.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55422338,13.1672173 C2.22398261,13.1672173 1.94511262,12.9167639 1.8895483,12.5705815 L0.00979687801,0.836002366 C-0.0206062404,0.646770867 0.0202807119,0.457539368 0.125119051,0.301701663 C0.229957391,0.145863958 0.385118133,0.0423431969 0.562294927,0.0100625295 C0.929229115,-0.0556119319 1.27834079,0.207085914 1.34124379,0.596680176 L3.21994683,12.3301462 C3.25034995,12.5193777 3.209463,12.7086092 3.10462466,12.8644469 C2.99978632,13.0202846 2.84462558,13.1238054 2.66744878,13.1560861 C2.63075536,13.1627648 2.59301356,13.1672173 2.55422338,13.1672173 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#CCFF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70461548,7.75408334 C4.6300225,7.75408334 3.63091312,8.09581316 2.79535156,8.68243081 L3.02285075,10.1027802 C3.74099338,9.43824368 4.67929652,9.03417877 5.70461548,9.03417877 C7.95968816,9.03417877 9.7943591,10.9821501 9.7943591,13.3764851 C9.7943591,15.7708201 7.95968816,17.7187914 5.70461548,17.7187914 C3.44954279,17.7187914 1.61487185,15.7708201 1.61487185,13.3764851 C1.61487185,13.0570178 1.64842012,12.7464555 1.71027474,12.4470245 L1.34753409,10.1862647 C0.756245855,11.0934627 0.409230951,12.1932317 0.409230951,13.3775982 C0.409230951,16.4776554 2.78486772,19 5.70461548,19 C8.62436323,19 11,16.4776554 11,13.3775982 C11,10.277541 8.62541161,7.75408334 5.70461548,7.75408334 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#CCFF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2.936883, 10.060481)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 2.47837834,
    cy: 5.83278267,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 4.73135426,
    cy: 4.94116837,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 2.95958632,
    cy: 3.29930684,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 0.721287775,
    cy: 4.08183474,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 5.19264295,
    cy: 2.51455268,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 3.44184268,
    cy: 0.765831007,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#1CD8D2",
    fillRule: "nonzero",
    cx: 1.18152809,
    cy: 1.65521905,
    rx: 1,
    ry: 1
  })))))))))));
};

export { SvgBoba as ReactComponent };
export default __webpack_public_path__ + "e748c94838e657627ded72f68ac4a566.svg";